const http = require('../lib/httpClient');
const {
  getCookie,
  getChannelId,
  getEcommId,
  getXCommerceValue,
  getItemInSessionStorage,
} = require('../lib/browserData');
const { COOKIES, COMMERCE_HEADER, SESSION_STORAGE } = require('../constants');

const catalystLogoutError = {
  code: 'CATALYST_LOGOUT_ERROR',
  message: 'Unable to logout',
};

const endpoint = '/s/auth/v1/logout';

async function catalystLogout(
  tenantId,
  catalystBaseUrl = '',
  additionalInfo = {},
  otpFlow = false,
) {
  let sessionId;

  if (otpFlow) {
    const userData = JSON.parse(getItemInSessionStorage(SESSION_STORAGE.USER_DATA));
    sessionId = userData && userData.sessionId;
  } else {
    sessionId = getCookie(COOKIES.SESSION.VALUE);
  }

  if (!sessionId) {
    return {
      success: false,
      errors: [{ code: 'LOGOUT_ERROR', message: 'Session not found' }],
    };
  }
  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { sessionId },
    {
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );
  const { responseBody } = result || {};
  if (!responseBody) return { success: false, errors: [catalystLogoutError] };
  const { active, errors } = responseBody;
  if (errors) return { success: false, errors };
  if (active) {
    return {
      success: false,
      errors: [{ code: 'LOGOUT_ERROR', message: 'Unable to logout user' }],
    };
  }
  return { success: true, errors: [] };
}

module.exports = catalystLogout;
